import { html } from 'lit';
const Insync =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M11 4.75a4.25 4.25 0 0 0-4.147 5.183.75.75 0 0 1-.568.896 3.252 3.252 0 0 0-1.435 5.609.75.75 0 1 1-.992 1.124 4.751 4.751 0 0 1 1.42-7.99A5.75 5.75 0 0 1 16.485 7.27a5.75 5.75 0 0 1 2.966 10.33.75.75 0 1 1-.901-1.2 4.25 4.25 0 0 0-2.635-7.65.75.75 0 0 1-.75-.6A4.25 4.25 0 0 0 11 4.75m-1.29 8.311a2.978 2.978 0 0 1 5.161 1.17.75.75 0 1 0 1.453-.373 4.478 4.478 0 0 0-8.036-1.4l-.57-.242a.3.3 0 0 0-.411.338l.474 2.283a.3.3 0 0 0 .454.192l1.971-1.246a.3.3 0 0 0-.043-.53zm2.063 5.327a2.97 2.97 0 0 0 2.278-1.062l-.453-.191a.3.3 0 0 1-.043-.53l1.971-1.247a.3.3 0 0 1 .454.193l.475 2.283a.3.3 0 0 1-.41.337l-.571-.241a4.47 4.47 0 0 1-3.701 1.958 4.47 4.47 0 0 1-4.336-3.358.75.75 0 1 1 1.453-.374 2.973 2.973 0 0 0 2.883 2.232" clip-rule="evenodd"/>
  </svg>
`;
export default Insync;
